import { translateFn } from '../../../../../../../../../../../utils/translator.helper';
import { ValidationResult } from '../../../../../../../../../../../ui/gzForm/formField/types/form-validator';
import {
  ExchangeAntimalwareScanTaskTargetExclusion,
  ExchangeAntimalwareScanTaskTargetExclusionType,
} from '@nirvana/shared/dtos/types/policies/common';
import { EmailValidator } from '../../../../../../../../../../../ui/gzForm/validators/email.validator';

// validate public folder
export function validatePublicFolder(scope: string): ValidationResult {
  const exchangePublicFolderRegex = /^\\/;
  if (!exchangePublicFolderRegex.test(scope)) {
    return {
      valid: false,
      error: translateFn('Invalid path. Path should start with "\\".'),
    };
  }

  return { valid: true };
}

// validate entity by type
export async function validateScopeByType(
  type: ExchangeAntimalwareScanTaskTargetExclusionType,
  scope: string
): Promise<ValidationResult> {
  switch (type) {
    case ExchangeAntimalwareScanTaskTargetExclusionType.EMAIL:
      return await EmailValidator(translateFn('Invalid email address'))(scope);
    case ExchangeAntimalwareScanTaskTargetExclusionType.PUBLIC_FOLDER:
      return validatePublicFolder(scope);
    default:
      return { valid: true };
  }
}

// validate duplicates
export function validateDuplicates(
  exclusionItem: ExchangeAntimalwareScanTaskTargetExclusion,
  exclusionsInGrid: ExchangeAntimalwareScanTaskTargetExclusion[]
): ValidationResult {
  const hasDuplicates = exclusionsInGrid.some(
    (exclusionInGrid: ExchangeAntimalwareScanTaskTargetExclusion) =>
      exclusionInGrid.type === exclusionItem.type && exclusionInGrid.scope === exclusionItem.scope
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
